export default __webpack_public_path__ + "static/media/bg-myimg3.a18954e8.jpg";